import { API, graphqlOperation } from 'aws-amplify'
import * as queries from '@/graphql/queries'
import * as customqueries from '@/graphql/customqueries'
import { getAllTableItems } from '../../../lib'
import { queryKeys } from '../../../constants/constant.js'

export default {
  state: {
    listPositionSod: [],
    listMargins: [],
    listMandatory: [],
    listVoluntary: [],
    listDailyPostmaster: [],
    listOvernightBuyingPower: [],
    listOrders: [],
    listStocks: [],
    listForms: [],
    listAccountInformations: [],
    listAchRelationshipStatics: [],
    listAchRelationships: [],
    // UserProfile: [],
  },
  getters: {
    getListPositionSod: (state) => state.listPositionSod,
    getListMargins: (state) => state.listMargins,
    getListMandatory: (state) => state.listMandatory,
    getListVoluntary: (state) => state.listVoluntary,
    getListDailyPostmaster: (state) => state.listDailyPostmaster,
    getListOrders: (state) => state.listOrders,
    getListStocks: (state) => state.listStocks,
    getListForms: (state) => state.listForms,
    getListAccountInformations: (state) => state.listAccountInformations,
    getListAchRelationshipStatics: (state) => state.listAchRelationshipStatics,
    getListAchRelationships: (state) => state.listAchRelationships,
    // getUserProfile: state => state.UserProfile,
  },
  mutations: {
    setListMargins: (state, list) => {
      state.listMargins = list
    },
    setListMandatory: (state, list) => {
      state.listMandatory = list
    },
    setListVoluntary: (state, list) => {
      state.listVoluntary = list
    },
    setListDailyPostmaster: (state, list) => {
      state.listDailyPostmaster = list
    },
    setListOrders: (state, list) => {
      state.listOrders = list
    },
    setListStocks: (state, list) => {
      state.listStocks = list
    }, //TODO can we make an edit in here like in positions to fix the issue with createdAt
    setListForms: (state, list) => {
      state.listForms = list
    },
    setListAccountInformations: (state, list) => {
      state.listAccountInformations = list
    },
    setListAchRelationshipStatics: (state, list) => {
      state.listAchRelationshipStatics = list
    },
    setListAchRelationships: (state, list) => {
      state.listAchRelationships = list
    },
    // setUserProfile: (state, list) => {
    //   state.UserProfile = list
    // },
    setListPositionSod: (state, list) => {
      for (const position of list) {
        if (position['ClosingPrice']) {
          position['ClosingPrice'] = Number(
            position['ClosingPrice']
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        }
        position['ConversionFactor'] = Number(
          position['ConversionFactor']
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        position['SettleQuantity'] = Number(
          position['SettleQuantity']
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        position['TradeQuantity'] = Number(
          position['TradeQuantity']
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        position['StrikePrice'] = Number(
          position['StrikePrice']
        ).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        position['Description'] === 'Equity'
          ? [
              (position['OptionSymbolRoot'] = ''),
              (position['StrikePrice'] = ''),
            ]
          : ''
        state.listPositionSod.push(position)
      }
    },
  },
  actions: {
    async fetchListMargins({ commit }) {
      try {
        const response = await API.graphql(
          graphqlOperation(queries.listMarginCallReports, {
            limit: 10,
            nextToken: undefined,
          })
        )
        commit('setListMargins', response.data.listMarginCallReports.items)
      } catch (e) {
        console.error('fetchListMargins', e)
      }
    },
    async fetchListDailyPostmaster({ commit }) {
      try {
        const response = await API.graphql(
          graphqlOperation(queries.listDailyPostmasters, {
            limit: 10,
            nextToken: undefined,
          })
        )
        commit(
          'setListDailyPostmaster',
          response.data.listDailyPostmasters.items
        )
      } catch (e) {
        console.error('fetchDailyPostmaster', e)
      }
    },
    async fetchOrders({ commit }) {
      try {
        const response = await API.graphql(
          graphqlOperation(queries.listOrders, {
            limit: 10,
            nextToken: undefined,
          })
        )
        commit('setListOrders', response.data.listOrders.items)
      } catch (e) {
        console.error('fetchOrders', e)
      }
    },
    async fetchListForms({ commit }) {
      try {
        const response = await API.graphql(
          graphqlOperation(queries.listForms, {
            // limit: 10,
            nextToken: undefined,
          })
        )
        commit('setListForms', response.data.listForms.items)
      } catch (e) {
        console.error('fetchForms', e)
      }
    },
    async fetchListStocks({ commit }, symbol) {
      console.log('fetchListStocks has been called', symbol)
      try {
        const response = await API.graphql(
          graphqlOperation(queries.listStocks, {
            filter: { symbol: { beginsWith: symbol } },
            items: { symbol },
          })
        )
        commit('setListStocks', response.data.listStocks.items)
      } catch (e) {
        console.error('fetchStocks', e)
      }
    },
    async fetchListPositionSods({ commit }) {
      console.log('fetchListPositionSods has been called')
      try {
        const response = await API.graphql(
          graphqlOperation(queries.listPositionSods, {
            // limit: 10,
            nextToken: undefined,
          })
        )
        console.log('fetchListPositionSods', response)
        // if (response.data.listPositions.nextToken) nextToken = response.data.listPositions.nextToken;
        commit('setListPositionSod', response.data.listPositionSods.items)
      } catch (e) {
        console.error(e)
      }
    },
    async fetchListAccountInformations({ commit }, accountNumber) {
      try {
        const response = await API.graphql(
          graphqlOperation(queries.listAccountInformations, {
            accountNumber: accountNumber,
          })
        )
        commit(
          'setListAccountInformations',
          response.data.listAccountInformations
        )
      } catch (e) {
        console.error('fetchAccountInformations', e)
      }
    },
    async fetchListAchRelationshipStatics({ commit }) {
      try {
        const response = await API.graphql(
          graphqlOperation(queries.listAchRelationshipStatics, {
            nextToken: undefined,
          })
        )
        commit(
          'setListAchRelationshipStatics',
          response.data.listAchRelationshipStatics.items
        )
      } catch (e) {
        console.error('fetchListAchRelationshipStatics', e)
      }
    },
    async fetchListAchRelationships({ commit }) {
      try {
        const relationships = await getAllTableItems(
          customqueries,
          queryKeys.listAchRelationships
        )

        relationships.sort(
          (a, b) =>
            Date.parse(b.achRelationshipStatic.createdAt) -
            Date.parse(a.achRelationshipStatic.createdAt)
        )

        commit('setListAchRelationships', relationships)
      } catch (e) {
        console.error('fetchListAchRelationships', e)
      }
    },
  },
}
